export const s3Url = function (path: string) {
	return `https://media.settlin.in/${path}`;
};
